import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Label,
  Form,
  FormGroup,
  FormField,
  Checkbox,
  Dropdown
} from 'semantic-ui-react'

const CardLaserUX = (props: any) => {
    return(
      <div
        id="CardLaser"
        style={{ margin: "15px",  padding: "20px",  backgroundColor: "rgba(198, 235, 243, 0.2)" }}>
        <div
          id="CardLaserUX-div-1"
          style={{ paddingBottom: "5px" }}>
          
          <label
            id="CardLaserUX-label-2"
            style={{ fontWeight: "bold", fontSize: "18px" }}>
            {props.languageUX === "en" ? "Laser (H)" : "Laser (H)"}
          </label>
          <Label
            color={props.statusColor}
            id="CardLaserUX-Label-3"
            style={{ float: "right" }}>
            {props.status}
          </Label>
          <hr
            id="CardLaserUX-hr-4">
          </hr>
        </div>
        <Form
          id="CardLaserUX-Form-166">
          <FormGroup
            id="CardLaserUX-FormGroup-167"
            inline={true}>
            <FormField
              className="required"
              id="CardLaserUX-FormField-168"
              inline={true}
              style={{display: "flex"}}>
              <label
                id="CardLaserUX-label-169"
                style={{minWidth: "110px", maxWidth: "110px"}}>
                {props.languageUX === "en" ? "Laser" : "Laser"}
              </label>
              <div
                id="CardLaserUX-div-170">
                
                <Checkbox
                  checked={props.islaser}
                  className="laser.chkLaser"
                  id="CardLaserUX-Checkbox-171"
                  label={props.islaser ? "YES" : "NO"}
                  name="is_laser"
                  onChange={props.handleChangeData}
                  toggle={true}>
                </Checkbox>
              </div>
            </FormField>
            <FormField
              id="CardLaserUX-FormField-172"
              inline={true}
              width={6}>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardLaserUX-Dropdown-173"
                multiple={true}
                name="laser"
                onChange={props.handleChangeData}
                options={props?.masterOptions?.orSurgicalLaser}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.laser}>
              </Dropdown>
            </FormField>
          </FormGroup>
        </Form>
        <div
          id="CardLaserUX-div-154"
          style={{ height: "55px", paddingTop: "15px" }}>
          
          <div
            id="CardLaserUX-div-155"
            style={{display:"flex",justifyContent:"flex-end"}}>
            
            <div
              id="CardLaserUX-div-163"
              style={{margin:"10px"}}>
              {props.buttonSave}
            </div>
            <div
              id="CardLaserUX-div-164"
              style={{margin:"10px"}}>
              {props.buttonConfirm}
            </div>
            <div
              id="CardLaserUX-div-165"
              style={{margin:"10px"}}>
              {props.buttonUnconfirm}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardLaserUX

export const screenPropsDefault = {}

/* Date Time : Thu Nov 20 2025 07:17:10 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLaser"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"15px\",  padding: \"20px\",  backgroundColor: \"rgba(198, 235, 243, 0.2)\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLaserUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ paddingBottom: \"5px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "label",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "Laser (H)",
          "valueEN": "Laser (H)"
        },
        "id": {
          "type": "value",
          "value": "CardLaserUX-label-2"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"18px\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "Label",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.status"
        },
        "color": {
          "type": "code",
          "value": "props.statusColor"
        },
        "id": {
          "type": "value",
          "value": "CardLaserUX-Label-3"
        },
        "style": {
          "type": "code",
          "value": "{ float: \"right\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "hr",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLaserUX-hr-4"
        }
      },
      "seq": 4,
      "void": true
    },
    {
      "from": null,
      "id": 154,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLaserUX-div-154"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"55px\", paddingTop: \"15px\" }"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": null,
      "id": 155,
      "name": "div",
      "parent": 154,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLaserUX-div-155"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\",justifyContent:\"flex-end\"}"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": null,
      "id": 163,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardLaserUX-div-163"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"10px\"}"
        }
      },
      "seq": 163,
      "void": false
    },
    {
      "from": null,
      "id": 164,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonConfirm"
        },
        "id": {
          "type": "value",
          "value": "CardLaserUX-div-164"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"10px\"}"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": null,
      "id": 165,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonUnconfirm"
        },
        "id": {
          "type": "value",
          "value": "CardLaserUX-div-165"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"10px\"}"
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 166,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLaserUX-Form-166"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 167,
      "name": "FormGroup",
      "parent": 166,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLaserUX-FormGroup-167"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 168,
      "name": "FormField",
      "parent": 167,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardLaserUX-FormField-168"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": null,
      "id": 169,
      "name": "label",
      "parent": 168,
      "props": {
        "children": {
          "type": "value",
          "value": "Laser",
          "valueEN": "Laser"
        },
        "id": {
          "type": "value",
          "value": "CardLaserUX-label-169"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"110px\", maxWidth: \"110px\"}"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": null,
      "id": 170,
      "name": "div",
      "parent": 168,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLaserUX-div-170"
        }
      },
      "seq": 170,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 171,
      "name": "Checkbox",
      "parent": 170,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.islaser"
        },
        "className": {
          "type": "value",
          "value": "laser.chkLaser"
        },
        "id": {
          "type": "value",
          "value": "CardLaserUX-Checkbox-171"
        },
        "label": {
          "type": "code",
          "value": "props.islaser ? \"YES\" : \"NO\""
        },
        "name": {
          "type": "value",
          "value": "is_laser"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 172,
      "name": "FormField",
      "parent": 167,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLaserUX-FormField-172"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 173,
      "name": "Dropdown",
      "parent": 172,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardLaserUX-Dropdown-173"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "laser"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "options": {
          "type": "code",
          "value": "props?.masterOptions?.orSurgicalLaser"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.laser"
        }
      },
      "seq": 173,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 85,
  "isMounted": false,
  "memo": false,
  "name": "CardLaserUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
